import { render, staticRenderFns } from "./customerLogin.vue?vue&type=template&id=da886206&scoped=true"
import script from "./customerLogin.vue?vue&type=script&lang=js"
export * from "./customerLogin.vue?vue&type=script&lang=js"
import style0 from "./customerLogin.vue?vue&type=style&index=0&id=da886206&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da886206",
  null
  
)

export default component.exports